import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Application from "@/pages/Application";
import Espaces from "@/pages/Espaces";
import Solutions from "@/pages/Solutions";
import Tarifs from "@/pages/Tarifs";
import Rejoindre from "@/pages/Rejoindre";
import Souscription from "@/pages/Souscription";
import Contact from "@/pages/Contact";
import Annonces from "@/pages/Annonces";
import AnnonceDetail from "@/pages/AnnonceDetail";
import Metiers from "@/pages/Metiers";
import Conseils from "@/pages/Conseils";
import ConseilDetail from "@/pages/ConseilDetail";
import { MentionsLegales, Confidentialite, Cookies } from "@/pages/Legal";
import Admin from "@/pages/Admin";
import CookieBanner from "@/components/CookieBanner";
import { ContentProvider } from "@/lib/content";
import FreePage from "@/pages/FreePage";
import Depannage from "@/pages/Depannage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <SmoothScroll>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/application" element={<Application />} />
                <Route path="/espaces" element={<Espaces />} />
                <Route path="/solutions" element={<Solutions />} />
                <Route path="/depannage" element={<Depannage />} />
                <Route path="/tarifs" element={<Tarifs />} />
                <Route path="/annonces" element={<Annonces />} />
                <Route path="/annonces/:id" element={<AnnonceDetail />} />
                <Route path="/metiers" element={<Metiers />} />
                <Route path="/rejoindre" element={<Rejoindre />} />
                <Route path="/souscription" element={<Souscription />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/conseils" element={<Conseils />} />
                <Route path="/conseils/:slug" element={<ConseilDetail />} />
                <Route path="/p/:slug" element={<FreePage />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/confidentialite" element={<Confidentialite />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Layout>
            <CookieBanner />
          </SmoothScroll>
        </ContentProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}

export default App;
